(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FormPoster"] = factory();
	else
		root["FormPoster"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createFormPoster;

var _formBuilder = __webpack_require__(1);

var _formBuilder2 = _interopRequireDefault(_formBuilder);

var _formPoster = __webpack_require__(2);

var _formPoster2 = _interopRequireDefault(_formPoster);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFormPoster() {
    var formBuilder = new _formBuilder2.default();
    var formPoster = new _formPoster2.default(formBuilder);

    return formPoster;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormBuilder = function () {
    function FormBuilder() {
        _classCallCheck(this, FormBuilder);
    }

    _createClass(FormBuilder, [{
        key: 'build',

        /**
         * @param {string} url
         * @param {Object} data
         * @returns {HTMLFormElement}
         */
        value: function build(url, data) {
            var _this = this;

            var form = document.createElement('form');

            form.style.display = 'none';

            form.setAttribute('action', url);
            form.setAttribute('method', 'POST');
            form.setAttribute('target', '_top');

            Object.keys(data).forEach(function (key) {
                var value = data[key];

                form.appendChild(_this._createInput(value, key));
            });

            return form;
        }

        /**
         * @private
         * @param {string} value
         * @param {string} key
         * @returns {HTMLInputElement}
         */

    }, {
        key: '_createInput',
        value: function _createInput(value, key) {
            var input = document.createElement('input');

            input.setAttribute('name', key);
            input.setAttribute('type', 'hidden');
            input.setAttribute('value', value);

            return input;
        }
    }]);

    return FormBuilder;
}();

exports.default = FormBuilder;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormPoster = function () {
    /**
     * @param {FormBuilder} formBuilder
     * @returns {void}
     */
    function FormPoster(formBuilder) {
        _classCallCheck(this, FormPoster);

        this._formBuilder = formBuilder;
    }

    /**
     * @param {string} url
     * @param {Object} data
     * @param {function(): void} [callback]
     * @returns {void}
     */


    _createClass(FormPoster, [{
        key: 'postForm',
        value: function postForm(url, data) {
            var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

            var form = this._formBuilder.build(url, data);

            window.addEventListener('beforeunload', function handleBeforeUnload() {
                window.removeEventListener('beforeunload', handleBeforeUnload);
                callback();
            });

            // In order to submit the form, the form must be attached to DOM.
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    }]);

    return FormPoster;
}();

exports.default = FormPoster;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormPoster = undefined;

var _createFormPoster = __webpack_require__(0);

var _createFormPoster2 = _interopRequireDefault(_createFormPoster);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createFormPoster = _createFormPoster2.default;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// form-poster.min.js